const React = require("react");
const PropTypes = require("prop-types");

const Container = ({ children }) => {
  return <div className="pane__container">{children}</div>;
};

Container.propTypes = {
  children: PropTypes.node.isRequired,
};

module.exports = Container;
